module.exports = __webpack_public_path__ + "static/img/Adam-MacDougall.68afaf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Adam-MacDougall.jpg
// module id = V2JP
// module chunks = 0